export const lyricsKeys = { song: (id: number) => ["lyrics", id] as const };
